export enum TypeUserInfo {
    Mobile, Tel, Address, Fax, Email, Location
}
export const ListOfTypeUserInfo = [
    {label:"آدرس",value:TypeUserInfo.Address},
    {label:"ایمیل",value:TypeUserInfo.Email},
    {label:"فکس",value:TypeUserInfo.Fax},
    {label:"لوکیشن",value:TypeUserInfo.Location},
    {label:"موبایل",value:TypeUserInfo.Mobile},
    {label:"تلفن ثابت",value:TypeUserInfo.Tel},
]